import { ReactElement } from 'react'
import classNames from 'classnames/bind'
import { useTranslation } from 'next-i18next'
import { ModalListItem } from '@frontend-mono/main/playlist/ui-modal-list-item'
import styles from './ModalContent.module.scss'

const cx = classNames.bind(styles)

type ModalContentProps = {
  list: {
    id: string
    title: string
    count: number
  }[]
  ModalNewButton: ReactElement
  onAdd: (id: string) => void
}

export const UiModalContent = ({ list, onAdd, ModalNewButton }: ModalContentProps) => {
  const { t } = useTranslation()

  return (
    <div className={cx('container')}>
      <div className={cx('title')}>{t('Topic_playlist_modal_title')}</div>
      <div className={cx('list')}>
        {list.map((item) => {
          return (
            <div
              className={cx('item')}
              key={item.id}
            >
              <ModalListItem {...item} onAdd={onAdd} />
            </div>
          )
        })}
      </div>
      <div className={cx('new')}>{ModalNewButton}</div>
    </div>
  )
}
